import { BattleManager } from "../BattleManager";
import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { BossLayer } from "../board-container/BossLayer";
import { AudioManager } from "../../../AudioManager";

export class HUD extends Phaser.GameObjects.Container {

    private creditsLabel: Phaser.GameObjects.Text;
    private lifesLabel: Phaser.GameObjects.Text;
    private roundLabel: Phaser.GameObjects.Text;
    private fpsLabel: Phaser.GameObjects.Text;
    private enteringEnemyFXContainer: Phaser.GameObjects.Container;
    private heartIcon: Phaser.GameObjects.Image;
    private lastWaveSignShown: boolean;
    private adButton: Phaser.GameObjects.Image;
    private adButtonText: Phaser.GameObjects.Text;

    private lastAdShownTime: number;

    constructor(scene: Phaser.Scene) {

        super(scene);

        if (!this.scene.sys.game.device.os.desktop) {
            this.scaleX = GameVars.scaleX + GameVars.contrascaleX;
        }
        this.lastAdShownTime = 0;
        this.x = GameConstants.GAME_WIDTH / 2;

        this.lastWaveSignShown = false;

        // EL MARCO ROJO DE CUANDO ENTRA UN ENEMIGO
        this.enteringEnemyFXContainer = new Phaser.GameObjects.Container(this.scene);
        this.enteringEnemyFXContainer.visible = false;
        this.add(this.enteringEnemyFXContainer);

        const upperRedFrameSide = new Phaser.GameObjects.Image(this.scene, 0, 45, "texture_atlas_1", "fx_enemy_traspass");
        upperRedFrameSide.setOrigin(.5, 0);
        upperRedFrameSide.scaleX = GameConstants.GAME_WIDTH / upperRedFrameSide.width;
        upperRedFrameSide.scaleY = .35;
        this.enteringEnemyFXContainer.add(upperRedFrameSide);

        const lowerRedFrameSide = new Phaser.GameObjects.Image(this.scene, 0, GameConstants.GAME_HEIGHT, "texture_atlas_1", "fx_enemy_traspass");
        lowerRedFrameSide.scaleY = -.35;
        lowerRedFrameSide.y += lowerRedFrameSide.height * lowerRedFrameSide.scaleY;
        lowerRedFrameSide.setOrigin(.5, 1);
        lowerRedFrameSide.scaleX = GameConstants.GAME_WIDTH / upperRedFrameSide.width;
        this.enteringEnemyFXContainer.add(lowerRedFrameSide);

        const leftRedFrameSide = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "fx_enemy_traspass");
        leftRedFrameSide.setOrigin(0, 1);
        leftRedFrameSide.angle = 90;
        leftRedFrameSide.scaleY = -.35;
        leftRedFrameSide.x = -this.x - leftRedFrameSide.height * leftRedFrameSide.scaleY;
        leftRedFrameSide.scaleX = GameConstants.GAME_HEIGHT / upperRedFrameSide.width;
        this.enteringEnemyFXContainer.add(leftRedFrameSide);

        const rightRedFrameSide = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "fx_enemy_traspass");
        rightRedFrameSide.setOrigin(0, 1);
        rightRedFrameSide.angle = 90;
        rightRedFrameSide.scaleY = .35;
        rightRedFrameSide.x = this.x - rightRedFrameSide.height * rightRedFrameSide.scaleY;
        rightRedFrameSide.scaleX = GameConstants.GAME_HEIGHT / upperRedFrameSide.width;
        this.enteringEnemyFXContainer.add(rightRedFrameSide);

        const background = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "bar_in_game");
        background.setOrigin(.5, 0);
        this.add(background);

        const topContainer = new Phaser.GameObjects.Container(this.scene);
        topContainer.scaleX = this.scene.sys.game.device.os.desktop ? 1 : (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;
        this.add(topContainer);

        const roundBack = new Phaser.GameObjects.Image(this.scene, -250, 35, "texture_atlas_1", "capsula");
        topContainer.add(roundBack);

        const skullIcon = new Phaser.GameObjects.Image(this.scene, -305, 35, "texture_atlas_1", "icon_waves");
        topContainer.add(skullIcon);

        this.roundLabel = new Phaser.GameObjects.Text(this.scene, -234, 32, BattleManager.anutoEngine.round + "/" + Object.keys(GameVars.wavesData).length, { fontFamily: "Lithos", fontSize: "24px", color: "#ffffff" });
        this.roundLabel.setStroke("#101e2f", 6);
        this.roundLabel.setShadow(4, 2, "#101e2f", 2, true, false);
        this.roundLabel.setOrigin(.5);
        topContainer.add(this.roundLabel);

        const lifesBack = new Phaser.GameObjects.Image(this.scene, -38, 35, "texture_atlas_1", "capsula");
        topContainer.add(lifesBack);

        this.heartIcon = new Phaser.GameObjects.Image(this.scene, -95, 33, "texture_atlas_1", "icon_heart");
        topContainer.add(this.heartIcon);

        this.lifesLabel = new Phaser.GameObjects.Text(this.scene, - 27, 32, " " + BattleManager.anutoEngine.lifes.toString() + " ", { fontFamily: "Lithos", fontSize: "24px", color: "#ffffff" });
        this.lifesLabel.setStroke("#101e2f", 6);
        this.lifesLabel.setShadow(3, 1, "#101e2f", 1, true, false);
        this.lifesLabel.setOrigin(.5);
        topContainer.add(this.lifesLabel);

        const creditsBack = new Phaser.GameObjects.Image(this.scene, 90, 35, "texture_atlas_1", "capsula");
        creditsBack.scaleX = 1.5;
        creditsBack.setOrigin(0, .5);
        topContainer.add(creditsBack);

        const creditIcon = new Phaser.GameObjects.Image(this.scene, 110, 33, "texture_atlas_1", "icon_build");
        topContainer.add(creditIcon);

        this.creditsLabel = new Phaser.GameObjects.Text(this.scene, 275, 32, " " + GameVars.formatNumber(BattleManager.anutoEngine.credits) + " ", { fontFamily: "Lithos", fontSize: "24px", color: "#ffffff" });
        this.creditsLabel.setStroke("#101e2f", 6);
        this.creditsLabel.setShadow(4, 2, "#101e2f", 2, true, false);
        this.creditsLabel.setOrigin(1, .5);
        topContainer.add(this.creditsLabel);

        this.adButton = new Phaser.GameObjects.Image(this.scene, 0, 0, "adbutton");
        this.adButton.x = this.creditsLabel.x - 50;
        this.adButton.y = this.creditsLabel.y + 50;
        topContainer.add(this.adButton);

        this.adButtonText = new Phaser.GameObjects.Text(this.scene, this.adButton.x + 5, this.adButton.y - 3, "+100", { fontFamily: "Lithos", fontSize: "18px", color: "#FFE232" });
        topContainer.add(this.adButtonText);
        this.adButtonText.setOrigin(0.5);
        this.adButton.setVisible(false);
        this.adButtonText.setVisible(false);

        topContainer.bringToTop(creditsBack);
        topContainer.bringToTop(creditIcon);
        topContainer.bringToTop(this.creditsLabel);


        if (!this.scene.sys.game.device.os.desktop) {
            this.addPatch();
        }

        if (GameConstants.DEVELOPMENT) {
            this.fpsLabel = new Phaser.GameObjects.Text(this.scene, - GameConstants.GAME_WIDTH / 2 + 15, 10, "", { fontFamily: "Rubik-Medium", fontSize: "22px", color: "#FFFFFF" });
            this.add(this.fpsLabel);
        } else {
            this.fpsLabel = null;
        }
    }

    public update(time: number, delta: number): void {

        this.creditsLabel.text = " " + GameVars.formatNumber(BattleManager.anutoEngine.credits) + " ";

        this.updateRound();

        if (GameConstants.DEVELOPMENT) {
            this.fpsLabel.text = Math.round(this.scene.game.loop.actualFps).toString();
        }
    }

    private tweenAdButton() {
        this.adButton.setVisible(true);
        this.adButtonText.setVisible(true);
        this.scene.add.tween({
            targets: this.adButton,
            y: { from: this.creditsLabel.y, to: this.creditsLabel.y + 50 },
            ease: Phaser.Math.Easing.Sine.Out,
            duration: 800,
        });

        this.scene.add.tween({
            targets: this.adButtonText,
            y: { from: this.creditsLabel.y - 3, to: this.creditsLabel.y + 47 },
            ease: Phaser.Math.Easing.Sine.Out,
            duration: 800,
        });
    }
    private showAdButtonIfPossible() {
        if (BattleManager.anutoEngine.credits > 40 || this.adButton.visible || this.scene.time.now - this.lastAdShownTime > 30000) {
            return;
        }

        if (typeof window.GameSnacks !== "undefined") {

            window.GameSnacks.ad.break({
                type: "reward",
                name: "reward_money",
                beforeReward: (showAdFn: any) => {
                    console.log("beforeReward");
                    if (typeof showAdFn === 'function') {
                        this.tweenAdButton();
                        this.adButton.setInteractive({ useHandCursor: true })
                            .once(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, () => {
                                this.adButton.setVisible(false);
                                this.adButtonText.setVisible(false);
                                this.lastAdShownTime = this.scene.time.now;
                                showAdFn();
                            }, this);
                    }
                },
                beforeAd: () => {
                    console.log("beforeAd");
                    AudioManager.muteSound();
                    AudioManager.muteSoundtrack();
                },
                adDismissed: () => {
                    console.log("adDismissed");
                },
                adViewed: () => {
                    console.log("adViewed");
                    BattleManager.anutoEngine.credits += 100;
                },
                afterAd: () => {
                    console.log("afterAd");
                    if (!GameVars.gameData.soundMuted) {
                        AudioManager.unMuteSound();
                    }
                    if (!GameVars.gameData.soundtrackMuted) {
                        AudioManager.unMuteSoundtrack();
                    }
                }
            });

        }
    }

    public showBossLayer(id: string): void {

        const bossLayer = new BossLayer(this.scene, id);
        this.add(bossLayer);
    }

    public onSuicideSoldierAdded(): void {

        const presentationImg = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2 + 140, GameConstants.GAME_HEIGHT + 30, "texture_atlas_1", "presentation_skill_pig");
        presentationImg.setOrigin(1);
        presentationImg.setScale(.5);
        this.addAt(presentationImg, 0);

        const presentatioBack = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2 + 140, GameConstants.GAME_HEIGHT + 30, "texture_atlas_1", "presentation_skill_pig_back");
        presentatioBack.setOrigin(1);
        presentatioBack.setScale(.5);
        this.addAt(presentatioBack, 0);

        this.scene.tweens.add({
            targets: presentatioBack,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 300,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: presentatioBack,
                    x: GameConstants.GAME_WIDTH / 2 + 300,
                    y: GameConstants.GAME_HEIGHT + 200,
                    ease: Phaser.Math.Easing.Cubic.In,
                    duration: 1000,
                    onComplete: () => {
                        presentatioBack.destroy();
                    },
                    onCompleteScope: this
                });
            },
            onCompleteScope: this
        });

        this.scene.tweens.add({
            targets: presentationImg,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 300,
            delay: 100,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: presentationImg,
                    x: GameConstants.GAME_WIDTH / 2 + 300,
                    y: GameConstants.GAME_HEIGHT + 200,
                    ease: Phaser.Math.Easing.Cubic.In,
                    duration: 1000,
                    onComplete: () => {
                        presentationImg.destroy();
                    },
                    onCompleteScope: this
                });
            },
            onCompleteScope: this
        });
    }

    public onFreezeAttackLaunched(): void {

        const presentationImg = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2 + 100, GameConstants.GAME_HEIGHT + 25, "texture_atlas_1", "presentation_skill_freeze");
        presentationImg.setOrigin(1);
        presentationImg.setScale(.5);
        this.addAt(presentationImg, 0);

        const presentatioBack = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2 + 140, GameConstants.GAME_HEIGHT + 30, "texture_atlas_1", "presentation_skill_pig_back");
        presentatioBack.setOrigin(1);
        presentatioBack.setScale(.5);
        this.addAt(presentatioBack, 0);

        this.scene.tweens.add({
            targets: presentatioBack,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 300,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: presentatioBack,
                    x: GameConstants.GAME_WIDTH / 2 + 300,
                    y: GameConstants.GAME_HEIGHT + 200,
                    ease: Phaser.Math.Easing.Quintic.In,
                    duration: 1000,
                    onComplete: () => {
                        presentatioBack.destroy();
                    },
                    onCompleteScope: this
                });
            },
            onCompleteScope: this
        });

        this.scene.tweens.add({
            targets: presentationImg,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 300,
            delay: 100,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: presentationImg,
                    x: GameConstants.GAME_WIDTH / 2 + 300,
                    y: GameConstants.GAME_HEIGHT + 200,
                    ease: Phaser.Math.Easing.Quintic.In,
                    duration: 1000,
                    onComplete: () => {
                        presentationImg.destroy();
                    },
                    onCompleteScope: this
                });
            },
            onCompleteScope: this
        });
    }

    public updateLifes(): void {

        this.lifesLabel.setText(" " + (BattleManager.anutoEngine.lifes < 0 ? "0" : BattleManager.anutoEngine.lifes.toString()) + " ");

        if (this.heartIcon.scaleX === 1 && !BattleManager.anutoEngine.gameOver) {

            if (BattleManager.anutoEngine.lifes > 0) {
                AudioManager.playSound("life_" + Math.ceil(Math.random() * 4));
            } else {
                AudioManager.playSound("life_final");
            }

            this.scene.tweens.add({
                targets: this.heartIcon,
                scaleX: 1.15,
                scaleY: 1.15,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 200,
                yoyo: true
            });
        }

        if (!this.enteringEnemyFXContainer.visible && !BattleManager.anutoEngine.gameOver) {

            this.enteringEnemyFXContainer.visible = true;
            this.enteringEnemyFXContainer.alpha = 0;

            this.scene.tweens.add({
                targets: this.enteringEnemyFXContainer,
                alpha: 1,
                ease: Phaser.Math.Easing.Cubic.InOut,
                duration: 300,
                yoyo: true,
                onComplete: () => {
                    this.enteringEnemyFXContainer.visible = false;
                },
                onCompleteScope: this
            });
        }
    }

    public activeNextWave() {
        this.showAdButtonIfPossible();
    }

    public onWaveOver(): void {
        //
    }

    private updateRound(): void {

        this.roundLabel.setText(BattleManager.anutoEngine.round + "/" + Object.keys(GameVars.wavesData).length);

        if (BattleManager.anutoEngine.round === Object.keys(GameVars.wavesData).length && !this.lastWaveSignShown) {

            this.lastWaveSignShown = true;

            const lastWaveSign = new Phaser.GameObjects.Image(this.scene, 0, 640, "texture_atlas_1", "final_wave_text");
            lastWaveSign.alpha = 0;
            this.add(lastWaveSign);

            this.scene.tweens.add({
                targets: lastWaveSign,
                alpha: 1,
                y: 620,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 400,
                onComplete: () => {
                    this.scene.tweens.add({
                        targets: lastWaveSign,
                        alpha: 0,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        delay: 2250,
                        duration: 450,
                        onComplete: () => {
                            lastWaveSign.destroy();
                        },
                        onCompleteScope: this
                    });
                },
                onCompleteScope: this
            });
        }
    }

    private addPatch(): void {

        let width = (GameConstants.GAME_WIDTH / (GameVars.scaleX + GameVars.contrascaleX) - GameConstants.GAME_WIDTH);

        let patch = new Phaser.GameObjects.Graphics(this.scene);
        patch.fillStyle(0x50414F);
        patch.fillRect(- GameConstants.GAME_WIDTH / 2 - (width / 2), 0, (width / 2), GameConstants.GAME_HEIGHT);
        this.add(patch);

        patch = new Phaser.GameObjects.Graphics(this.scene);
        patch.fillStyle(0x50414F);
        patch.fillRect(GameConstants.GAME_WIDTH / 2, 0, (width / 2) / GameVars.scaleX, GameConstants.GAME_HEIGHT);
        this.add(patch);

        let imgPatch = new Phaser.GameObjects.Image(this.scene, (- GameConstants.GAME_WIDTH / 2), 0, "texture_atlas_1", "lateral_frame");
        imgPatch.setOrigin(0);
        imgPatch.scaleX = -GameVars.scaleX;
        this.add(imgPatch);

        let gradientPatch = new Phaser.GameObjects.Image(this.scene, - GameConstants.GAME_WIDTH / 2 - (width / 2), 0, "texture_atlas_1", "patch_gradient");
        gradientPatch.setOrigin(0);
        gradientPatch.setScale((width / 2) / gradientPatch.width, GameConstants.GAME_HEIGHT);
        this.add(gradientPatch);

        imgPatch = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2, 0, "texture_atlas_1", "lateral_frame");
        imgPatch.setOrigin(0);
        imgPatch.scaleX = GameVars.scaleX;
        this.add(imgPatch);

        gradientPatch = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2 + (width / 2), 0, "texture_atlas_1", "patch_gradient");
        gradientPatch.setOrigin(0);
        gradientPatch.setScale(-(width / 2) / gradientPatch.width, GameConstants.GAME_HEIGHT);
        this.add(gradientPatch);
    }
}
